import React, { Fragment} from "react";
import { Container } from "reactstrap";

import Referrals   from "./Referrals";

const ReferralsPage = () => {

  return (
    <Fragment>
      <Container fluid>
        <h1 className="main-title"> Refferals </h1>
        <Referrals/>
      </Container>
    </Fragment>
  );
};

export default ReferralsPage;
